module.exports = __webpack_public_path__ + "static/img/4.13f8f9b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/1/sp/4.png
// module id = LR1i
// module chunks = 0